// extracted by mini-css-extract-plugin
export var container = "styles-module__container___f1liH";
export var banner = "styles-module__banner___P2WEs";
export var dateAndActivity = "styles-module__dateAndActivity___HyeGo";
export var metadata = "styles-module__metadata___QHuNx";
export var nameAndDescription = "styles-module__nameAndDescription___vxiRq";
export var name = "styles-module__name___aLM1C";
export var nameAndStars = "styles-module__nameAndStars___Ae6fz";
export var description = "styles-module__description___xOSFS";
export var trackName = "styles-module__trackName___I0K1Q";
export var favoriteButton = "styles-module__favoriteButton___KCQ9M";
export var starsBlock = "styles-module__starsBlock___SJJrn";